import { render, staticRenderFns } from "./SocialsPopoverQrcode.vue?vue&type=template&id=5fe37d06&scoped=true&"
import script from "./SocialsPopoverQrcode.vue?vue&type=script&lang=js&"
export * from "./SocialsPopoverQrcode.vue?vue&type=script&lang=js&"
import style0 from "./SocialsPopoverQrcode.vue?vue&type=style&index=0&id=5fe37d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe37d06",
  null
  
)

export default component.exports